

































































































































































/* Created- 03 - Oct - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentStreamDTO, ContentStreamBillingConfigurationDTO, ContentStreamDTOOwner } from "../../Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
@Component(
	{
		name: "ContentStreamCreate"
	})
export default class ContentStreamCreate extends Vue {
	@Prop() private stream: ContentStreamDTO;
	@Prop({ default: "Save" }) private buttonLabel: string;
	private billing: ContentStreamBillingConfigurationDTO = new ContentStreamBillingConfigurationDTO();
	private currentstep: number = 1;

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 0, } as FormFieldRules
		} as IFormField;

	private ownerconfig =
		{
			props: {
				name: "owner",
				placeholder: "Owner",
				label: "Stream Owner", required: true, disabled: false,
				values: [
					{ label: "Partica", value: "partica" } as EnumDTO,
					{ label: "Corelogic", value: "corelogic" } as EnumDTO,
					{ label: "MyDesign", value: "myDesign" } as EnumDTO,
					{ label: "ActivePipe", value: "activePipe" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;
	private descriptionconfig =
		{
			props: { name: "description", placeholder: "Enter description", label: "Description", } as FormFieldProps,
			rules: { required: true, max: 500, min: 0, } as FormFieldRules
		} as IFormField;

	private visibilityconfig =
		{
			props: {
				name: "visibility",
				placeholder: "Choose visibility",
				label: "Billing", required: true, disabled: false,
				values: [
					{ label: "Chargebee subscription", value: "privateChargebeeBilledStream" } as EnumDTO,
					{ label: "Invoiced", value: "nonChargebeeBilledStream" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private categoryconfig =
		{
			props: {
				name: "category",
				placeholder: "Choose category",
				label: "Category", required: true, disabled: false, values: [{ label: "Real Estate", value: "realEstate" } as EnumDTO,],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private copyIssueOnSubscribeconfig =
		{
			props: {
				name: "copyIssueOnSubscribe",
				placeholder: "Choose what to copy when a user subscribes.",
				label: "Initial articles for subscriber.", required: true,
				values: [
					{ label: "Do not copy any articles", value: "none" } as EnumDTO,
					{ label: "Copy articles from first issue", value: "first" } as EnumDTO,
					{ label: "Copy articles from most recent issue", value: "last" } as EnumDTO,
					{ label: "Copy all issues", value: "all" } as EnumDTO
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private numberArticlesconfig =
		{
			props: {
				name: "numberArticles",
				placeholder: "Enter Number Articles",
				label: "Number of articles per issue.",
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private maximumValueContentconfig =
		{
			props: {
				name: "maximumValueContent",
				placeholder: "Enter Maximum Value",
				label: "Maximum value for content in an issue.",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;

	private billingDayconfig =
		{
			props: {
				name: "billingDay",
				placeholder: "Enter Billing Day",
				label: "The day each month each subscriber will be billed.",
			} as FormFieldProps,
			rules: { required: true, max_value: 28, min_value: 1, numeric: true } as FormFieldRules
		} as IFormField;

	private contentOwnerContributionconfig =
		{
			props: {
				name: "ContentOwnerContribution",
				placeholder: "Enter per subscription content owner contribution",
				label: "Content Owner Contribution",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;

	private preFinaliseIssueEditingFeeconfig =
		{
			props: {
				name: "PreFinaliseIssueEditingFee",
				placeholder: "Enter pre finalise issue editing fee",
				label: "Pre Finalise Issue Editing Fee",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;

	private serviceFeeconfig =
		{
			props: {
				name: "ServiceFee",
				placeholder: "Enter monthly service fee for this stream",
				label: "Monthly Service Fee",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;



	private isParticaOwned(): boolean {
		if (this.stream.owner === ContentStreamDTOOwner.Partica) {
			return true;
		}
		return false;
	}

	private createStream() {
		this.stream.contentStreamBillingConfigurations[0] = this.billing;
		this.$emit("partica-event", { action: eParticaAction.CONTENT_STREAM_SAVE, item: this.stream } as ParticaEvent);
	}

	private mounted() {
		this.billing = this.stream.contentStreamBillingConfigurations[0];
	}

}
